export enum DownloadStatus {
  Unknown = "unknown",
  NotSupported = "not_supported",
  NotFound = "not_found",
  Found = "found",
  Expired = "expired",
}
